import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { ButtonComponent } from '../../../../../shared/ui/button/button.component';

export type ProductNotFoundReason = 'not_found' | 'disabled';

@Component({
  selector: 'app-product-not-found',
  imports: [ButtonComponent],
  templateUrl: './product-not-found.component.html',
  styleUrl: './product-not-found.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductNotFoundComponent {
  reason = input<ProductNotFoundReason>('not_found');
  goToCatalog = output<void>();

  protected readonly heading = computed(() =>
    this.reason() === 'disabled'
      ? 'Este producto ya no está disponible'
      : 'No encontramos este producto',
  );

  protected readonly body = computed(() =>
    this.reason() === 'disabled'
      ? 'Fue retirado del catálogo. Explora productos similares para encontrar lo que buscas.'
      : 'Es posible que el producto haya sido retirado o que el enlace no sea correcto. Explora nuestro catálogo para encontrar lo que buscas.',
  );
}
